// set base url for api base on NODE_ENV
export const baseURL =
    process.env.NODE_ENV === "development" ? "http://127.0.0.1:8000/api" : "https://meiexterminator.it/api";

/************* AUTHENTICATION ***************/
export const loginUrl = `/auth/login/`;
export const logoutUrl = `/auth/logout/`;

/************* USER ***************/
export const userDetailsUrl = `/user/`;

/************* COSTUMER ***************/
export const costumersListUrl = `/costumers/`;
export const costumerDetailUrl = (id: number) => `${costumersListUrl}${id}/`;
export const costumerRestoreUrl = (id: number) => `${costumerDetailUrl(id)}restore/`;
export const costumerDeadlineStartpointUrl = (id: number) => `${costumersListUrl}${id}/deadline_startpoint/`;

/************* INSPECTION ***************/
export const inspectionsListUrl = `/inspections/`;
export const syncInspectionsUrl = `${inspectionsListUrl}sync/`;
export const inspectionsSendMailUrl = (id: number) => `/inspections/${id}/send`;
export const inspectionsSendSimplifiedMailUrl = (id: number) => `/inspections/${id}/send-simplified`;
export const inspectionPrintUrl = (id: number) => `/inspections/${id}/print`;
export const inspectionSimplifiedPrintUrl = (id: number) => `/inspections/${id}/print_simplified`;

/************* CONTRACT ***************/
export const contractsListUrl = `/contracts/`;
export const contractsDeadlinesPreviewUrl = `${contractsListUrl}deadlines_preview/`;
export const contractsDetailUrl = (id: number) => `${contractsListUrl}${id}/`;
export const contractPrintUrl = (id: number) => `${contractsListUrl}${id}/print/`;
export const contractPrintYearPlanUrl = (id: number) => `${contractsListUrl}${id}/print-year-planning/`;
export const contractPrintFinalReportUrl = (id: number) => `${contractsListUrl}${id}/print-final-report/`;

export const contractSendUrl = (id: number) => `${contractsListUrl}${id}/send`;
export const contractSendYearPlaUrl = (id: number) => `${contractsListUrl}${id}/year-planning/send`;
export const contractSendFinalReportUrl = (id: number) => `${contractsListUrl}${id}/final-report/send`;

/************* INSPECTION FREQUENCY ***************/
export const inspectionsFrequenciesListUrl = `/inspections-frequencies/`;
export const inspectionsFrequenciesDetailsUrl = (id: number) => `/inspections-frequencies/${id}/`;

/************* INSPECTION SCHEDULE ***************/
export const interventionsScheduleListUrl = `/interventions-schedule/`;
export const interventionsScheduleReorderUrl = `/interventions-schedule/reorder/`;
export const interventionsScheduleDetailUrl = (id: number) => `${interventionsScheduleListUrl}${id}/`;

/************* TRAP ***************/
export const trapsListUrl = `/traps/`;

/************* ZONE ***************/
export const zonesListUrl = `/zones/`;
export const zoneDetailUrl = (id: number) => `${zonesListUrl}${id}/`;
export const zoneAssignCostumersUrl = (id: number) => `/zones/${id}/assign-costumers/`;

/************* CALENDAR ***************/
export const calendarEventsUrl = `/events/`;

/************* PING ***************/
export const pingUrl = `/ping/`;
